import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NotificationsService } from 'angular2-notifications';
import { AttachFileDialogComponent } from '../../../../../app/modules/document-in-library/attach-file-dialog/attach-file-dialog.component';
import { OrdinalDateParse } from '../../adapters/ordinal-date-adapter';
import { Department, LeavesTypesVM, NewLeaveInfo, SiteCodes } from '../../entities/global/model';
import { MY_FORMATS } from '../../search-form-analysisreporting/search-form-analysisreporting.component';
import { SafetyConfigService } from '../../services/safety-config.service';
import { SafetyLeavesService } from '../../services/safety-leaves.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-create-new-leave',
  templateUrl: './create-new-leave.component.html',
  styleUrls: ['./create-new-leave.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' }
  ],
})
export class CreateNewLeaveComponent implements OnInit {
  mindate:Date= new Date();
  title:string;
  siteCodesList: SiteCodes[] = [];
  departmentlist_:Department[];
  departmentlist:Department[];

  leavesTypesList:LeavesTypesVM[]= []
  ord: OrdinalDateParse = new OrdinalDateParse();
  selectedLeaveType:number;
  selectedDep:number;
  selectedState:number;
  LeaveFrom:Date;
  LeaveTo:Date
  Notes:string
  IsEdit:boolean=false;
  LeaveInfo:NewLeaveInfo;

  NewFileName:string="";
  FilePreview:string="";
  Extension:string="";

  LeaveReqId:number=0;
  constructor(public dialogRef: MatDialogRef<CreateNewLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _dialog: MatDialog,
    private _notify: NotificationsService,
    private _safetyConfigService: SafetyConfigService,
    private _safetyLeaves :SafetyLeavesService) { }

  ngOnInit() {
    this.title = this.data.title;
    this.IsEdit=this.data.IsEdit;

    
    this.loadSiteList();
    this.loadLeavesTypes();


    if(this.IsEdit==true){
      this.LoadAlDepartments();
      this.LeaveInfo = this.data.LeaveInfo;
      this.LeaveReqId = this.LeaveInfo.Id;
      this.selectedDep=this.LeaveInfo.DepartmentId;
      this.selectedState=this.LeaveInfo.StateId;
      this.LeaveFrom=this.LeaveInfo.LeaveFrom;
      this.LeaveTo=this.LeaveInfo.LeaveTo;
      this.FilePreview=this.LeaveInfo.Attachment;
      this.Extension=this.LeaveInfo.Extention;
      this.Notes=this.LeaveInfo.Note;



    }
  }
  loadSiteList() {
    this._safetyConfigService.getAllSitesList().subscribe(sites => {
      console.log('sitelist', sites)
      this.siteCodesList = sites;

    });
  }

LoadAlDepartments(){
  this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    
    this.departmentlist=res.Departments;
    this.departmentlist_  =  this.departmentlist.filter(x=>x.SiteId == this.selectedState);
    this.selectedDep = this.LeaveInfo.DepartmentId;
  });
}
  loadLeavesTypes(){
    this._safetyLeaves.GETAllLeavesTypes().subscribe(res=>{
      this.leavesTypesList =res;

      if(this.IsEdit==true){
        this.selectedLeaveType = this.LeaveInfo.LeaveTypeId;
      }
    })
  }

  stateChanged(event:any)
  {
    let value=event.value
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
      this.departmentlist=res.Departments;
      this.departmentlist_  =  this.departmentlist.filter(x=>x.SiteId == value);
    })
  }

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  DialogClose(): void {
    this.dialogRef.close(false);
  }

  CreateOrUpdateLeaveRequest(){
    const params = new NewLeaveInfo();
    params.DepartmentId=this.selectedDep;
    params.StateId=this.selectedState;
    params.LeaveFrom=this.LeaveFrom;
    params.LeaveTo=this.LeaveTo;
    params.LeaveTypeId=this.selectedLeaveType;
    params.Note=this.Notes;
    params.Attachment=this.FilePreview;
    params.Extention=this.Extension;
    params.Id =this.LeaveReqId;


    console.log("dataa__", params)
    this._safetyLeaves.CreateNewLeaveRequest(params).subscribe(res=>{
      if(res==true){
        this._notify.success("Created New Request Successfully")
        this.dialogRef.close(true);
      }else{
        this._notify.error("Unable to Create new Leave Request")
      }
    })

  }


 

 
  openAttachDoc()
  {
    const dialogRef = this._dialog.open(AttachFileDialogComponent, {
      data: { 
        NewFileName:this.NewFileName,
        FilePreview:this.FilePreview
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log("res",res)
      if (res !=false) {
        this.FilePreview=res.FilePreview; 
        this.NewFileName=res.NewFileName;
        this.Extension=res.Extension;
        
      }
   
    });
    
  }

  onClickDownloadForm(FilePreview) {

    var newstring = this.FilePreview.slice(1);
    console.log('length ', newstring.length - 1)

    let _newstring = newstring.substring(0, newstring.length - 1);
    console.log("newstringnewstringnewstring", _newstring)

    var arrBuffer = this.base64ToArrayBuffer(this.FilePreview);

    if(this.Extension =='pdf'){
      var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.pdf';
      link.click();
    }
    else if(this.Extension =='xls'){
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.xls';
      link.click();
    }
    else if(this.Extension =='docx'){
      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.docx';
      link.click();
    }
    else if(this.Extension =='png'){
      var blob = new Blob([arrBuffer], { type: 'image/png' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.png';
      link.click();
    }

    else if(this.Extension =='jpg'){
      var blob = new Blob([arrBuffer], { type: 'image/jpg' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.jpg';
      link.click();
    }

    else if(this.Extension =='txt'){
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.txt';
      link.click();
    }
}

base64ToArrayBuffer(base64) {
  console.log("base64", base64)
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

// Date
dateChangedLeaveFrom(): void {

  console.log("from_", this.LeaveFrom)
  this.ord.formatDateOrdinal((this.LeaveFrom.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);
}

dateChangedLeaveTo(): void {
  console.log("to_", this.LeaveTo)

  this.ord.formatDateOrdinal((this.LeaveTo.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);
}

}
